module.exports = __webpack_public_path__ + "static/img/home_bottom.ad3281f4.png";